import axios from 'axios'
import { tokenStorage } from '@/services/tokenStorage'
import { getClientInfoHeaders } from '@/services/clientInfoHeaders'
import { convertErrMessage } from '@/utils/commonUtils'
import { emitSessionExpired } from '@/services/sessionExpiredEvents'

const apiBaseURL = process.env.REACT_APP_API_SERVICE_URL
// const apiBaseURL = 'http://localhost:9998/api/v1'


const ApisServiceApp = axios.create({
  baseURL: apiBaseURL,
  responseType: 'json',
})

ApisServiceApp.defaults.timeout = 60000
ApisServiceApp.defaults.headers.post['Content-Type'] = 'application/json'

ApisServiceApp.interceptors.request.use(
  function (config) {
    const token = tokenStorage.getAccessToken()
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    Object.entries(getClientInfoHeaders()).forEach(([k, v]) => config.headers.set(k, v))
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

function statusFallback(status?: number): string {
  if (status === 400) return 'Dữ liệu không hợp lệ'
  if (status === 401) return 'Phiên đăng nhập đã hết hạn'
  if (status === 403) return '403 - Bạn không có quyền'
  if (status === 404) return 'Không tìm thấy dữ liệu'
  if (status != null && status >= 500) return 'Lỗi máy chủ, vui lòng thử lại'
  return 'Đã xảy ra lỗi'
}

/** 401 ở các API này là sai mật khẩu / phiên đăng nhập đang dựng — không bật modal đăng nhập lại. */
const SESSION_EXPIRED_IGNORE_URLS = [
  '/auth/login',
  '/auth/logout',
  '/users/sso/dang-nhap',
  '/users/sso/dang-xuat',
  '/users/sso/lam-moi-token',
]

ApisServiceApp.interceptors.response.use(
  function (response) {
    return response.data
  },
  function (error) {
    // Giữ nguyên lỗi hủy request để caller nhận diện được bằng `axios.isCancel`.
    if (axios.isCancel(error)) return Promise.reject(error)
    const status = error?.response?.status as number | undefined
    if (status === 401) {
      const url = String(error?.config?.url ?? '').split('?')[0]
      if (!SESSION_EXPIRED_IGNORE_URLS.some((ignored) => url.endsWith(ignored))) {
        emitSessionExpired()
      }
    } else if (status === 403) {
      console.log('403 - Forbidden')
    }
    const data = error?.response?.data
    const text = convertErrMessage(error) || statusFallback(status)
    // Nest validation trả `message` là mảng. Giữ nguyên body (code, statusCode)
    // nhưng ép `message` thành chuỗi để toast không hiện "undefined".
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      return Promise.reject({ ...data, message: text, statusCode: data.statusCode ?? status })
    }
    return Promise.reject({ message: text, statusCode: status })
  }
)

export default ApisServiceApp
